export class FilmDetailsComponentPropsApi {
    /**
     * Label for the film's directors.
     */
    directorsLabel?: string = 'Directors'
    /**
     * Label for the film's actors.
     */
    actorsLabel?: string = 'Actors'
    /**
     * Label for the film's synopsis.
     */
    synopsisLabel?: string = 'Synopsis'
    /**
     * Label for the film's runtime.
     */
    runtimeLabel?: string = 'Runtime'
    /**
     * Label for the film's release date.
     */
    releaseDateLabel?: string = 'Release Date'
    /**
     * The format of the release date.
     */
    releaseDateFormat: string = '${date|d|D MMMM YYYY}'
    /**
     * The label shown on the action button.
     */
    actionButtonLabel: string = 'View Showtimes'
    /**
     * The optional label shown on the play trailer button.
     */
    playTrailerButtonLabel?: string
    /**
     * Label text for the trailer video player error message title.
     */
    failedToLoadTrailerTitle: string = 'Sorry, something went wrong.'
    /**
     * Label text for the trailer video player error reload button.
     */
    failedToLoadTrailerRetryButtonLabel: string = 'Retry'
    /**
     * The format for the advance booking period notification shown if the film is not available until a later date.
     * Default: Tickets on sale at select cinemas from ${startsAt|d|Do of MMMM, h:mm A}.
     */
    advanceBookingPeriodNotificationFormat: string =
        'Tickets on sale at select cinemas from ${startsAt|d|Do of MMMM, h:mm A}.'
    /**
     * The format for the advance booking period notification shown if the film is not available until later today.
     * Default: Tickets on sale at select cinemas today from ${startsAt|d|h:mm A}.
     */
    advanceBookingPeriodTodayNotificationFormat: string =
        'Tickets on sale at select cinemas today from ${startsAt|d|h:mm A}.'
}
